export const CacheRegions = {
    Application: 'application'
};
